import { Component, OnInit, Output, EventEmitter  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Dep } from '../class/auth';
import { chartdata }  from '../class/chatdata';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import * as Highcharts from 'highcharts';
import { Options } from "highcharts";
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';
import * as moments from 'moment-timezone';

@Component({
    selector: 'app-tradelist',
    templateUrl: './tradelist.component.html',
    styleUrls: ['./tradelist.component.css']
})

export class TradelistComponent implements OnInit {

    constructor(
        public httpClient: HttpClient,
        private  route: ActivatedRoute,
    ){}
    Highcharts: typeof Highcharts = Highcharts;
    pieOptions: any =  JSON.parse(JSON.stringify(chartdata.pie));
    pieOptions2: any = JSON.parse(JSON.stringify(chartdata.pie));
    link:string = environment.link;
    search_model:string = '';
    gender_model: string = 'all';
    sort_model:string = 'desc';
    order_model:string = 'id';
    data:any=[];
    edit_data:any=[];
    urltoken :string = '';
    preurl :string = '';
    time :any = {start:'',end:''};
    updateFlag:boolean=false;
    barOptions:any = {...this.getUpdatedOptions()};
    barOptions2:any = {...this.getUpdatedOptions()};
    barOptions3:any = {...this.getUpdatedOptions()};
    tmp_img_b64:any='';
    loading:boolean=true;
    send_para: { year: string } = {
        year: (new Date().getFullYear() - 2).toString()
    }
    menu_list:menulist = [
        {id:'1',name:'儲值數據'},
        {id:'10',name:'首儲紀錄'},
        {id:'8',name:'藍新重新驗證'},
        {id:'11',name:'綠界重新驗證'},
        {id:'5',name:'雙平台驗證失敗紀錄'},
        {id:'9',name:'國家分群'},
        {id:'2',name:'儲值日分群'},
        {id:'3',name:'平台分析'},
        {id:'4',name:'各月金額'},
        {id:'6',name:'年紀總儲值'},
        {id:'7',name:'年紀客單價'}
    ];

    country_list:menulist = [
        {"id": "all", "name": "不分國家"},
        {"id": "1", "name": "美、加"},
        {"id": "44", "name": "英國"},
        {"id": "60", "name": "馬來西亞"},
        {"id": "61", "name": "澳大利亞"},
        {"id": "62", "name": "印度"},
        {"id": "63", "name": "菲律賓"},
        {"id": "65", "name": "新加坡"},
        {"id": "66", "name": "泰國"},
        {"id": "81", "name": "日本"},
        {"id": "234", "name": "奈及利亞"},
        {"id": "353", "name": "愛爾蘭"},
        {"id": "358", "name": "芬蘭"},
        {"id": "852", "name": "香港"},
        {"id": "886", "name": "台灣"}
    ];

    year_list:menulist = [{id:'2023',name:'2023年'},{id:'2024',name:'2024年'},{id:'2025',name:'2025年'}];

    pageobj:page = {page:0,count:6,total_count:0};
    pageobjstr:string = JSON.parse(JSON.stringify(this.pageobj))
    ranges: any = {
        '今天': [moment(), moment()],
        '昨天': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        '過去一周': [moment().subtract(6, 'days'), moment()],
        '過去30天': [moment().subtract(29, 'days'), moment()],
        '本月': [moment().startOf('month'), moment().endOf('month')],
        '過去一個月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    }
    type_option: any[] = [
        { "id": 'all', "name": "全部平台" },
        { "id": '200', "name": "iOS" },
        { "id": '100', "name": "Android" },
        { "id": '4', "name": "藍新" },
        { "id": '5', "name": "So-net" },
        { "id": '6', "name": "USDT" },/*{ "id": '2', "name": "外部轉帳" }, { "id": '3', "name": "綠界" },*/
        { "id": '7', "name": "綠界" },/*{ "id": '2', "name": "外部轉帳" }, { "id": '3', "name": "綠界" },*/
    ];
    status_option: any[] = [
        { "id": 'all', "name": "全部狀態" },
        { "id": '-9', "name": "處理中" },
        { "id": '-1', "name": "交易失敗" },
        { "id": '0', "name": "退款" },
        { "id": '1', "name": "成功" }
    ];
    check_option: any[] = [
        { "id": 'all', "name": "忽略驗證" },
        { "id": '-1', "name": "驗證有誤" },
        { "id": '0', "name": "未驗證" },
        { "id": '1', "name": "已驗證" }
    ];
    type_model:string = 'all';
    status_model:string = 'all';
    check_model:string = 'all';
    country_model:string = 'all';

    // 交易狀態多選
    trade_status_option: any[] = [
        { id: '-9',  name: '後台處理中',  checked: true },
        { id: '-8',  name: '後台處理中',  checked: true },
        { id: '-4',  name: '未開訂單',    checked: false },
        { id: '-2',  name: '手動註銷(藍新故障)', checked: false },
        { id: '-1',  name: '訂單逾期',    checked: false },
        { id: '0',   name: '未付款',      checked: true },
        { id: '1',   name: '付款成功',    checked: false },
        { id: '2',   name: '付款失敗',    checked: false },
        { id: '3',   name: '取消付款',    checked: false },
    ];
    trade_status_open: boolean = false;

    get selectedTradeStatusLabel(): string {
        const selected = this.trade_status_option.filter(o => o.checked);
        if (selected.length === 0) return '交易狀態(全部)';
        return selected.map(o => o.name).join(', ');
    }

    get selectedTradeStatusIds(): string[] {
        const selected = this.trade_status_option.filter(o => o.checked).map(o => o.id);
        return selected.length > 0 ? selected : [];
    }

    toggleTradeStatusDropdown() {
        this.trade_status_open = !this.trade_status_open;
    }

    onTradeStatusChange() {
        // 等按確認再打 API
    }
    info: any[];
    now:string = '1';
    all_money:string = '0';
    all_people:string = '0';
    avg_profit:string = '0';
    tcontent = [];
    //table compoment
    title = [];
    //title = data的key值  type: 1:圖片compoment 2.會員compoment 3.innerHTML輸出方式
    content = [];
    custom = '';
    timeset = [
        { type:1 , name: "今天", num: -0 },
        { type:3 , name: "昨天", num: -1 },
        { type:1 , name: "過去一周", num: -7 },
        { type:1 , name: "過去30天", num: -30 },
        { type:1 , name: "過去半年", num: 182 },
        { type:1 , name: "過去1年", num: -365 }
    ];

    // 首儲紀錄變數:
    firstDeposit_data:any=[];
    firstdeposit_status_option: any[] = [ //這裡是下拉選單的生成項目
        { "id": "4", "name": "全部" },
        { "id": "3", "name": "已派獎" },
        { "id": "2", "name": "待派獎" },
        { "id": "1", "name": "評估資格" },
        { "id": "-1", "name": "不派獎" }
    ];

    firstdeposit_status_table_option: any[] = [ //對照first_deposit status。
        { "key": "3", "value": "已派獎" },
        { "key": "2", "value": "待派獎" },
        { "key": "1", "value": "待判斷(男)" },
        { "key": "0", "value": "待判斷(女)" },
        { "key": "-1", "value": "不派獎" },
        { "key": "-2", "value": "活動未開始" },
        { "key": "-3", "value": "額滿不派獎" }
    ];

    firstdeposit_time :any = {start:'',end:''};
    firstdeposit_search_model:string = '';
    firstdeposit_gender_model: string = '0';  //首儲查詢的，預設選擇 "全部"
    firstdeposit_status_selected: string = '4'; // 預設選擇 "全部"
    firstDepositPage: page = {page:0, count:10, total_count:0};
    firstDepositPageStr: string = JSON.parse(JSON.stringify(this.firstDepositPage))
    years: number[] = [];
    ngOnInit(): void {
        const base = Number(this.send_para.year);
        this.years = [base + 2, base + 1, base];
        if(this.route.snapshot.paramMap.get('id')){
          this.search_model = this.route.snapshot.paramMap.get('id');
        }
        if(this.route.snapshot.paramMap.get('now')){
            this.now = this.route.snapshot.paramMap.get('now');
            this.search_model = this.route.snapshot.paramMap.get('name');
        }
        this.init_list();
    }

    firstDepositShowDatePickered(){
        this.firstdeposit_time.start =  '';
        this.firstdeposit_time.end =  '';
        this.firstdeposit_list();
    }

    firstDepositHandleRangeSelected( value: any ): void {
        let eventDate = value.event;
        this.firstdeposit_time.start =  '';
        this.firstdeposit_time.end =  '';

        if(eventDate.startDate){
            this.firstdeposit_time.start =  moment(eventDate.startDate).format('YYYY-MM-DD')
            this.firstdeposit_time.end =  moment(eventDate.endDate).format('YYYY-MM-DD')
        }else{
            this.firstdeposit_time.start =  '';
            this.firstdeposit_time.end =  '';
        }

        this.firstdeposit_list();

    }

    handleRangeSelected( value: any,type ): void {
        let  eventDate = value.event;
        // console.log(eventDate.startDate)
        this.time.startDate =  '';
        this.time.endDate =  '';

        if(eventDate.startDate){
            this.time.start =  moment(eventDate.startDate).format('YYYY-MM-DD')
            this.time.end =  moment(eventDate.endDate).format('YYYY-MM-DD')
        }else{
            this.time.start =  '';
            this.time.end =  '';
        }
        if(type==1){
          this.init_list();
        }else{
          this.choose('9');
        }
    }

    init_attributes(){
        // console.log("this.now:" + this.now)
        switch (this.now) {
            case '1':
                this.tcontent = [
                    {title:'日期',content:'usa_create_dt',type:3},
                    {title:'會員',content:'name',type:2},
                    {title:'大頭貼',content:'profile_pic',type:1},
                    {title:'金額',content:'nt_dollar'},
                    {title:'鑽石',content:'diamond'},
                    {title:'方式',content:'tname'},
                    {title:'狀態',content:'sname'},
                    {title:'驗證',content:'vname'},
                    {title:'交易id',content:'trade_id'},
                ];

                this.title = [{title:'日期'},{title:'會員'},{title:'大頭貼'},{title:'金額'},{title:'鑽石'},{title:'方式'},{title:'狀態'},{title:'驗證'},{title:'交易id'}];
                this.content = [{title:'usa_create_dt',type:3},{title:'name',type:2},{title:'profile_pic',type:1},{title:'nt_dollar'},{title:'diamond'},{title:'tname'},{title:'sname'},{title:'vname'},{title:'trade_id'}];
                break;
            case '8':

                this.tcontent = [
                    {title:'日期',content:'usa_create_dt',type:3},
                    {title:'會員',content:'name',type:2},
                    {title:'大頭貼',content:'profile_pic',type:1},
                    {title:'金額',content:'nt_dollar'},
                    {title:'鑽石',content:'diamond'},
                    {title:'狀態',content:'status'},
                    {title:'交易id',content:'trade_id'},
                    {title:'操作',content:'operation',type:3},
                ];
                this.title = [{title:'日期'},{title:'會員'},{title:'大頭貼'},{title:'金額'},{title:'鑽石'},{title:'交易id'},{title:'操作'}];
                this.content = [{title:'usa_create_dt',type:3},{title:'name',type:2},{title:'profile_pic',type:1},{title:'nt_dollar'},{title:'diamond'},{title:'trade_id'},{title:'gg',model:2 ,css:"cursor: pointer;"}];
                break;

            case '11':

                this.tcontent = [
                    {title:'日期',content:'usa_create_dt',type:3},
                    {title:'會員',content:'name',type:2},
                    {title:'大頭貼',content:'profile_pic',type:1},
                    {title:'金額',content:'nt_dollar'},
                    {title:'鑽石',content:'diamond'},
                    {title:'狀態',content:'status'},
                    {title:'交易id',content:'trade_id'},
                    {title:'操作',content:'operation',type:3},
                ];
                this.title = [{title:'日期'},{title:'會員'},{title:'大頭貼'},{title:'金額'},{title:'鑽石'},{title:'交易id'},{title:'操作'}];
                this.content = [{title:'usa_create_dt',type:3},{title:'name',type:2},{title:'profile_pic',type:1},{title:'nt_dollar'},{title:'diamond'},{title:'trade_id'},{title:'gg',model:2 ,css:"cursor: pointer;"}];
                break;
            case '5':

                this.tcontent = [
                    {title:'日期',content:'usa_create_dt',type:3},
                    {title:'會員',content:'name',type:2},
                    {title:'大頭貼',content:'profile_pic',type:1},
                    {title:'交易序號',content:'trade_id'},
                    {title:'金額',content:'nt_dollar'},
                    {title:'鑽石',content:'diamond'},
                    {title:'重確認',content:'re_check_times'},
                    {title:'操作',content:'gg',model:2 ,css:"cursor: pointer;"},
                ];

                this.custom = '<a title="點我重驗證"><i style="margin-right:10px" class="fas fa-redo-alt"></i></a>';
                this.title = [{title:'日期'},{title:'會員'},{title:'大頭貼'},{title:'交易序號'},{title:'金額'},{title:'鑽石'},{title:'重確認'},{title:'操作'}];
                this.content = [{title:'usa_create_dt',type:3},{title:'name',type:2},{title:'profile_pic',type:1},{title:'trade_id'},{title:'nt_dollar'},{title:'diamond'},{title:'re_check_times'},{title:'gg',model:2 ,css:"cursor: pointer;"}];
                break;

              case '10':
                this.tcontent = [
                  { title: '資料建立時間', content: 'create_dt', type: 3 }, // usa_create_dt
                  { title: '女會員名稱', content: 'female_name', type: 2 , active: 7}, // 女用戶名稱
                  { title: '女生大頭貼', content: 'female_profile_pic', type: 1 }, // 女用戶頭像
                  { title: '男會員名稱', content: 'male_name', type: 2, active: 6}, // 男用戶名稱
                  { title: '男生大頭貼', content: 'male_profile_pic', type: 1 }, // 男用戶頭像
                  { title: '男會員首儲日期', content: 'reward_create_dt' }, // 首次儲值日期
                  { title: '男會員首消日期', content: 'consume_create_dt' }, // 首次消費日期
                  { title: '首消鑽石數量', content: 'consume_diamond' }, // 首消鑽石數量
                  { title: '派獎狀態', content: 'status' } // 首消鑽石數量
                ];
                this.title = [
                  {title:'建立時間'},
                  {title:'女會員名稱'},
                  {title:'女生大頭貼'},
                  {title:'男會員名稱'},
                  {title:'男生大頭貼'},
                  {title:'首次儲值日期'},
                  {title:'首次消費日期'},
                  {title:'首消鑽石數量'},
                  {title:'派獎狀態'}
                ];
                this.content = [
                  {title:'create_dt', type:3},
                  {title:'male_name', type:2, active: 6},
                  {title:'male_profile_pic', type:1},
                  {title:'female_name', type:2, active: 7},
                  {title:'female_profile_pic', type:1},
                  {title:'reward_create_dt'},
                  {title:'consume_create_dt'},
                  {title:'consume_diamond'},
                  {title:'status'}
                ];
                break;
            default:
                break;
        }
    }

    handleClick($event){
        this.re_check($event);
    }

    // 重新驗證
    re_check(item){

        this.loading = true;
        const body = {
            trade_id:item.id,
            action:this.now
        };
        this.httpClient.post<any>("/v1/common/re_check_deposit.php",body).subscribe(res => {
            this.loading = false;
            alert(res.msg);
            this.init_list();
            console.log(res)
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
        });
    }

    getUpdatedOptions(){
        return chartdata.muti_bar;
    }

    choose(value:string){
        if(value !='1' && value != '5' && value != '8' && value != '11'){
            if(value == "10"){
                this.now = value;
                // console.log("this.now: " + this.now);
                this.firstdeposit_list();
            } else{
                this.get_chat_info(value);
                this.barOptions = {...this.getUpdatedOptions()};
                this.barOptions2 = {...this.getUpdatedOptions()};
                this.barOptions3 = {...this.getUpdatedOptions()};
                this.updateFlag = true;
            }
        }else{
            this.now = value;
            this.pageobj.page = 0;
            this.init_list();
        }
    }

    get_chat_info(now){
        this.loading = true;
        const body = {
            type:now,
            country_code:this.country_model,
            time:this.time,
            page: this.pageobj.page,count:this.pageobj.count,
            data:this.send_para
        };
        this.httpClient.post<any>("/v1/common/get_deposit_chat.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                if(now*1==9){
                    this.pieOptions.series = [res.data.os_data];
                    this.pieOptions2.series = [res.data.type_data];
                    this.all_money = res.data.all_money
                    this.all_people = res.data.all_people
                    this.avg_profit = res.data.avg_profit
                    this.updateFlag = true;
                }else{
                    let title = now == 4||now==6||now==7? '台幣':'人數';
                    this.barOptions.yAxis.title.text = title;
                    this.barOptions.title.text = '各月儲值分析'
                    this.barOptions2.title.text = '各月儲值分析'
                    this.barOptions3.title.text = '各月儲值分析'
                    this.barOptions.xAxis = {categories:res.chat_data.month}
                    this.barOptions.series = res.chat_data.data;
                    this.barOptions2.xAxis = {categories:res.chat_data2.month}
                    this.barOptions2.series = res.chat_data2.data;
                    this.barOptions3.xAxis = {categories:res.chat_data3.month}
                    this.barOptions3.series = res.chat_data3.data;
                }
            }
            this.now = now;
            console.log(res);
        });
    }

    firstdeposit_list(){
        this.loading = true;
        const body = {
            page: this.firstDepositPage.page,
            count:this.firstDepositPage.count,
            type:this.now,
            gender: this.firstdeposit_gender_model,  // 性別
            status: this.firstdeposit_status_selected, // 派獎狀態
            search: this.firstdeposit_search_model,
            time:this.firstdeposit_time,
            action:this.now,
        };
        // console.log("firstdeposit_list body:" + JSON.stringify(body) );
        this.httpClient.post<any>("/v1/common/get_deposit_chat.php", body).subscribe(res => {
            this.loading = false;
            if(res.data.data.length != undefined){ // 如果資料為0 會顯示undefined
                if(res.status){
                  this.firstDeposit_data = res.data.data;
                  this.firstDepositPage.total_count = res.data.total_count;
                } else{
                  this.firstDepositPage.total_count = 0;
                  this.firstDeposit_data = [];
                }
                // **轉換 status 為對應的中文名稱**
                this.firstDeposit_data.forEach(element => {
                    let statusObj = this.firstdeposit_status_table_option.find(item => item.key == element.status);
                    element.status = statusObj ? statusObj.value : "未知狀態"; // 若找不到則顯示 "未知狀態"
                });
                this.init_attributes();
                this.firstDepositPageStr = JSON.parse(JSON.stringify(this.firstDepositPage))
            }else{
                this.firstDepositPage.total_count = 0;
                this.firstDeposit_data = [];
            }
        },
        error => {
            // **捕捉 HTTP 錯誤，避免卡住**
            this.loading = false;
            console.error("API請求錯誤:", error);
            alert("請求失敗，請稍後再試！");
        });
    }

    init_list(){
        this.loading = true;
        const body = {
            page: this.pageobj.page,
            count:this.pageobj.count,
            type:this.type_model,
            status:this.status_model,
            gender:this.gender_model,
            search:this.search_model,
            check:this.check_model,
            time:this.time,
            action:this.now,
            trade_status: this.selectedTradeStatusIds,
        };
        this.httpClient.post<any>("/v1/common/get_deposit_record.php", body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.data = res.data;
                this.pageobj.total_count = res.total_count
                this.info = res.summary;
            } else{
                this.pageobj.total_count = 0
                this.data = [];
                this.info = [];
            }
            this.init_attributes();
            this.data.forEach(element => {
                const momentDate = moments(element.create_dt);
                momentDate.tz('America/Los_Angeles');
                element.usa_create_dt = element.create_dt + '<br>美西時間<br>' + momentDate.format('YYYY-MM-DD HH:mm:ss');
            });

            this.pageobjstr = JSON.parse(JSON.stringify(this.pageobj))
        });
    }

    callback(pageobj:page){
        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
            this.pageobj = pageobj;
            this.init_list();
        }
    }

    firstDeposit_callback(firstDepositPage:page){
        if(JSON.stringify(this.firstDepositPage) != JSON.stringify(firstDepositPage)){
            this.firstDepositPage = firstDepositPage;
            this.firstdeposit_list();
        }
    }
}
